// Tabs for game page
document.addEventListener("DOMContentLoaded", function() {
  var tabs = document.querySelectorAll('.tab');
  var tabContents = document.querySelectorAll('.tab-content');
  var highlightBar = document.querySelector('.highlight-bar');
  var tabsContainer = document.querySelector('.tabs');

  function moveHighlight(tab) {
      var leftPos = tab.getBoundingClientRect().left - tabsContainer.getBoundingClientRect().left;
      var width = tab.offsetWidth;
      highlightBar.style.left = leftPos + 'px';
      highlightBar.style.width = width + 'px';
  }

  // Move the highlight to the initial active tab
  var activeTab = document.querySelector('.tab.active');
  if(activeTab) {
      moveHighlight(activeTab);
  }

  tabs?.forEach(function(tab) {
      tab.addEventListener('click', function() {
          tabs.forEach(function(tab) {
              tab.classList.remove('active');
          });
          tab.classList.add('active');
          moveHighlight(tab);
          
          // Handle tab-content visibility
          var tabData = tab.getAttribute('data-tab');
          tabContents.forEach(function(content) {
              if (content.getAttribute('data-content') === tabData) {
                  content.classList.add('active');
              } else {
                  content.classList.remove('active');
              }
          });
      });

      tab.addEventListener('mouseover', function() {
          moveHighlight(this);
      });
  });

  // Move the highlight back to the active tab when not hovering over a tab
  tabsContainer?.addEventListener('mouseout', function(e) {
      if (!e.relatedTarget || !tabsContainer.contains(e.relatedTarget)) {
          // Find the current active tab and move the highlight to it
          var activeTab = document.querySelector('.tab.active');
          moveHighlight(activeTab);
      }
  });
});

//Tabs schedules center
document.addEventListener("DOMContentLoaded", function() {

    let tabs = document.querySelectorAll('.schedule-tabs button');
    let tabContents = document.querySelectorAll('.schedule-content .schedule');

    tabs.forEach(function(tab) {

        tab.addEventListener('click', function() {

            let tabName = this.getAttribute('data-tab');
    
            tabContents.forEach(function(content) {

                if (content.getAttribute('data-tab') === tabName) {
                    tab.classList.add('active');
                    content.classList.add('active');
                } else {
                    tab.classList.remove('active');
                    content.classList.remove('active');
                }
            });
    
            tabs.forEach(function(tab) {
                tab.classList.remove('active');
            });

            this.classList.add('active');
        });
    });

})

var swiper = new Swiper(".featured", {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: ".featured-game-button-next",
        prevEl: ".featured-game-button-prev",
    },
    breakpoints: {
        767: {
            slidesPerView: 2,
        },
        991: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    }
})